module.exports = __webpack_public_path__ + "img/高通3.19135174.png";